import React, { useEffect } from 'react'
import { CategoryCard } from '../cards/CategoryCard'
import { useArticleTemplate } from 'common/hooks/useArticleTemplate'

export const MostPublishedCategorySection = ({ nr }: { nr: number }) => {
  const { mostPublishedCategory, loadMostPublishedCategory } =
    useArticleTemplate({ pageSize: 1 })

  useEffect(loadMostPublishedCategory, [loadMostPublishedCategory])

  return (
    <div className='flex flex-col gap-6 lg:gap-[50px]'>
      <h3 className='font-bold text-lg md:text-2xl lg:text-[32px] text-[#001A3D]'>
        Most published
      </h3>

      <div className='grid grid-cols-2 auto-rows-fr gap-6'>
        {mostPublishedCategory.slice(0, nr).map((element) => (
          <CategoryCard
            key={element.id}
            blogCount={element.blog_count}
            label={element.name}
          />
        ))}
      </div>
    </div>
  )
}
